import { useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

// GET e PUT (salvar) no quarkus.
export function usePrintSettings() {
  const fetchSettings = useCallback(
    () => quarkusApi.get('/impressao/campos-do-tratamento', authHeader()),
    [],
  );

  const saveSettings = useCallback(
    (settings) => quarkusApi.put('/impressao/campos-do-tratamento', settings, authHeader()),
    [],
  );

  return { fetchSettings, saveSettings };
}
